import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CollectionRoomType,
  IBooth,
  ICollection,
  ICollectionRoom,
  IColors,
  ICustomApp,
  IKeynote,
  INetworking,
  IReception,
  ITradeFair,
  IWorkshop
} from '@sv/interfaces';
import { Observable, of } from 'rxjs';
import { BoothAnalyticsService } from 'src/app/_services/_analytics/booth-analytics.service';
import { CollectionService } from 'src/app/_services/_content/collection.service';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { TradefairService } from 'src/app/_services/_content/_TradeFair/tradefair.service';
import { BoothOverviewComponent } from '../_tradefair/booth-overview/booth-overview.component';
import * as _ from 'lodash';
import { KeynoteService } from 'src/app/_services/_content/keynote.service';
import { EventAnalyticsService } from 'src/app/_services/_analytics/event-analytics.service';
import { customApp } from 'src/app/_configuration/configuration';
import { NetworkingService } from 'src/app/_services/_content/networking.service';
import { WorkshopService } from 'src/app/_services/_content/workshop.service';
import { ReceptionService } from 'src/app/_services/_content/reception.service';

@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})
export class CollectionComponent implements OnInit, OnDestroy {
  constructor(
    private collectionService: CollectionService,
    private customAppService: CustomAppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fairService: TradefairService,
    private matDialog: MatDialog,
    private boothAnalyticsService: BoothAnalyticsService,
    private keynoteService: KeynoteService,
    private eventAnalyticsService: EventAnalyticsService,
    private networkingService: NetworkingService,
    private workshopService: WorkshopService,
    private receptionService: ReceptionService
  ) {
    this.tagsCtrl.valueChanges.subscribe((search) => {
      this.filteredTags = of(this.availableTags.filter((tag) => tag.toLowerCase().includes(search)));
    });
  }

  app: ICustomApp;
  colors: IColors;
  activeCollection: ICollection;

  mobile = false;
  document: Document = document;
  expanded = -1;
  loaded = false;

  searchValue = '';
  searchText: string;
  filteredBooths: any[] = [];

  onlyExpos = true;

  // tags
  tagsCtrl = new FormControl();
  filteredTags: Observable<string[]>;
  searchedTags: string[] = [];
  availableTags: string[] = [];
  @ViewChild('tagsInput') tagsInput: ElementRef<HTMLInputElement>;
  @ViewChild('tagsAutoFill') matAutocomplete: MatAutocomplete;
  // tags

  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
  }

  ngOnInit(): void {
    this.mobile = document.documentElement.clientWidth < 699;

    this.customAppService.getCustomAppListener().subscribe((app) => {
      this.app = app;
      this.colors = this.app.colors as IColors;
    });

    this.collectionService.getCollectionListener().subscribe((collection) => {
      this.activeCollection = collection;
      this.searchText = this.activeCollection.searchText ?? 'Search Expos';

      // REFACTOR ME ANSTATT EXPOID TYP NUTZEN
      this.onlyExpos = this.activeCollection.rooms.filter((room) => !room.expoId).length > 0 ? false : true;

      // prepare search for expos
      if (this.onlyExpos) {
        // combine expos tags to filter by
        this.activeCollection.rooms.forEach((expoSettings) => {
          const expo = expoSettings.expoId as ITradeFair;
          const filteredTags = expo?.settings.availableTags.filter((tag) => {
            return !this.availableTags.includes(tag);
          });
          this.availableTags = this.availableTags.concat(filteredTags);
        });

        // preparation for mobile search
        this.customAppService.setCollectionActive(this.searchText);
        if (this.onlyExpos) {
          this.customAppService.getboothSearchValue().subscribe((val) => {
            if (val) {
              this.searchValue = val;
            } else {
              this.searchValue = '';
            }
            this.searchExpos();
          });
        }
      }

      this.loaded = true;
    });
  }

  ngOnDestroy(): void {
    this.customAppService.setCollectionActive(undefined);
  }

  addTagFilter(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      if (this.availableTags.includes(value)) {
        this.searchedTags.push(value);
        event.input.value = '';
        this.tagsCtrl.setValue(null);
        this.tagsCtrl.updateValueAndValidity();
        this.searchValue = '';
        this.searchExpos();
      }
    }
  }

  removeTagFilter(tag: string): void {
    const index = this.searchedTags.indexOf(tag);

    if (index >= 0) {
      this.searchedTags.splice(index, 1);
      this.searchExpos();
    }
  }

  selectedTagOption(event: MatAutocompleteSelectedEvent): void {
    this.searchedTags.push(event.option.viewValue);
    this.searchExpos();
    this.tagsInput.nativeElement.value = '';
    this.tagsCtrl.setValue('');
    this.tagsCtrl.updateValueAndValidity();
    this.searchText = '';
  }

  filterBooths() {
    let filterdBooths = [];
    for (const expo of this.activeCollection.rooms) {
      filterdBooths = filterdBooths.concat(
        (expo.expoId as ITradeFair).booths.filter((booth) => {
          for (const tag of booth.settings.selectedTags) {
            if (this.searchedTags.includes(tag)) {
              return true;
            }
          }
          return false;
        })
      );
    }
    return filterdBooths;
  }

  enterRoom(room: ICollectionRoom) {
    switch (room.type) {
      case CollectionRoomType.EXPO:
        this.fairService.setFair(room.expoId);
        this.router.navigate([(room.expoId as ITradeFair)._id], { relativeTo: this.activatedRoute });
        break;
      case CollectionRoomType.KEYNOTE:
        this.keynoteService.setKeynote(room.keynoteId);
        this.router.navigate([(room.keynoteId as IKeynote)._id], { relativeTo: this.activatedRoute });
        break;
      case CollectionRoomType.NETWORKING:
        this.networkingService.setNetworking(room.networkingId);
        this.router.navigate([(room.networkingId as INetworking)._id], { relativeTo: this.activatedRoute });
        break;
      case CollectionRoomType.WORKSHOP:
        this.workshopService.setWorkshop(room.workshopId);
        this.router.navigate([(room.workshopId as IWorkshop)._id], { relativeTo: this.activatedRoute });
        break;
      case CollectionRoomType.RECEPTION:
        this.receptionService.setReception(room.receptionId);
        this.router.navigate([(room.receptionId as IReception)._id], { relativeTo: this.activatedRoute });
        break;
      case CollectionRoomType.COLLECTION:
        this.collectionService.setCollection(room.collectionId);
        this.router.navigate([(room.collectionId as ICollection)._id], { relativeTo: this.activatedRoute });
        break;
      default:
        break;
    }
    this.eventAnalyticsService.startCollectionRoomDuration(this.activeCollection._id, customApp.eventId, room._id);
  }

  searchExpos(fromControl?: boolean) {
    if (fromControl) {
      this.searchValue = this.tagsCtrl.value;
    }
    let filterdBooths = [];
    // filter set; filter has priority over all other searches
    if (this.searchedTags.length > 0) {
      filterdBooths = this.filterBooths();
      filterdBooths = filterdBooths.filter((booth) => {
        const lowerSearchVal = this.searchValue?.toLowerCase();
        const boothName = booth.settings.name.toLowerCase();
        const slogan = booth.settings.slogan.toLowerCase();
        const text = booth.settings.text.toLowerCase();
        const textHeadline = booth.settings.textHeadline.toLowerCase();
        const textSubHeadline = booth.settings.textSubHeadline?.toLowerCase();

        return (
          boothName.includes(lowerSearchVal) ||
          slogan.includes(lowerSearchVal) ||
          text.includes(lowerSearchVal) ||
          textHeadline.includes(lowerSearchVal) ||
          textSubHeadline?.includes(lowerSearchVal)
        );
      });
    } else {
      for (const expo of this.activeCollection.rooms) {
        filterdBooths = filterdBooths.concat(
          (expo.expoId as ITradeFair)?.booths.filter((booth) => {
            const lowerSearchVal = this.searchValue?.toLowerCase();
            const boothName = booth.settings.name.toLowerCase();
            const slogan = booth.settings.slogan.toLowerCase();
            const text = booth.settings.text.toLowerCase();
            const textHeadline = booth.settings.textHeadline.toLowerCase();
            const textSubHeadline = booth.settings.textSubHeadline?.toLowerCase();

            return (
              boothName.includes(lowerSearchVal) ||
              slogan.includes(lowerSearchVal) ||
              text.includes(lowerSearchVal) ||
              textHeadline.includes(lowerSearchVal) ||
              textSubHeadline?.includes(lowerSearchVal)
            );
          })
        );
      }
    }
    if (filterdBooths) {
      const finalFilter = [];
      const groupedBytradefair = _.groupBy(filterdBooths, 'tradeFairName');
      _.forEach(groupedBytradefair, (booths, tradefairName) => {
        finalFilter.push({ tradefairName, booths });
      });
      this.filteredBooths = finalFilter;
    }
    if (this.searchValue ? this.searchValue.trim().length === 0 : true && this.searchedTags.length === 0) {
      this.filteredBooths = [];
    }
  }

  openBooth(booth: IBooth): void {
    this.boothAnalyticsService.startDuration(booth._id);

    if (!this.mobile) {
      this.matDialog.open(BoothOverviewComponent, {
        data: { boothId: booth._id, showExpoTag: true, currentRoute: this.activatedRoute },
        hasBackdrop: false,
        closeOnNavigation: true,
        autoFocus: true,
        width: '90%',
        maxWidth: '1100px',
        panelClass: 'boothDialog'
      });
    } else {
      this.matDialog.open(BoothOverviewComponent, {
        data: { boothId: booth._id, showExpoTag: true, currentRoute: this.activatedRoute },
        hasBackdrop: false,
        closeOnNavigation: true,
        autoFocus: true,
        height: '100%',
        width: '100%',
        maxHeight: '100vh',
        panelClass: 'boothDialog'
      });
    }
  }
  scrollToTop(el: HTMLElement): void {
    el.scrollIntoView();
  }
}
